import React from 'react';
import RocketsContainer from '../components/RocketsContainer';

const Rockets = () => (
  <>
    <RocketsContainer />
  </>
);

export default Rockets;
